/**
 * 批量创建成功明细导出为 JSON（键为资产名称，值为资产ID）。
 *
 * @param {Array<Object>} successList 成功记录列表，元素包含 assetId 和 assetName 字段。
 * @param {string} [filenamePrefix='批量创建资产成功名称ID'] 下载文件名前缀。
 * @returns {void}
 */
export function exportBatchSuccessCsv(successList, filenamePrefix = '批量创建资产成功名称ID') {
    if (!Array.isArray(successList) || successList.length === 0) {
        return;
    }
    const jsonMap = {};
    successList.forEach((item) => {
        const assetName = String(item.assetName ?? '').trim();
        const assetId = String(item.assetId ?? '').trim();
        if (!assetName || !assetId) {
            return;
        }
        jsonMap[assetName] = assetId;
    });
    const content = JSON.stringify(jsonMap, null, 4);
    const blob = new Blob([content], { type: 'application/json;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    const ts = new Date().toISOString().slice(0, 19).replace(/[-:T]/g, '');
    a.download = `${filenamePrefix}_${ts}.json`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}
